/**
 * @fileoverview Contenedor de Inversión de Control (IoC)
 * Centraliza la creación y configuración de dependencias
 */

import FirebaseAuthRepository from '../repositories/FirebaseAuthRepository';
import FirestoreAnalyticsRepository from '../repositories/FirestoreAnalyticsRepository';
import AuthUseCase from '../../application/use-cases/AuthUseCase';
import AnalyticsUseCase from '../../application/use-cases/AnalyticsUseCase';
import MemoryCache from '../cache/MemoryCache';
import logger from '../logging/logger';

// El logger ahora se importa desde '../logging/logger'

/**
 * @function createAuthUseCase
 * @description Fábrica para crear instancia de AuthUseCase con todas sus dependencias
 * @returns {AuthUseCase} Instancia configurada de AuthUseCase
 */
export const createAuthUseCase = () => {
  const authRepository = new FirebaseAuthRepository(logger);
  return new AuthUseCase(authRepository, logger);
};

/**
 * @function createAnalyticsUseCase
 * @description Fábrica para AnalyticsUseCase con repositorio Firestore y caché en memoria
 * @returns {AnalyticsUseCase}
 */
export const createAnalyticsUseCase = () => {
  const analyticsRepository = new FirestoreAnalyticsRepository(logger);
  const cache = new MemoryCache(logger);
  return new AnalyticsUseCase(analyticsRepository, logger, cache);
};

/**
 * Contenedor central de servicios
 * Implementación simple de Service Locator Pattern
 */
const container = {
  logger,
  get authUseCase() {
    return createAuthUseCase();
  },
  get analyticsUseCase() {
    return createAnalyticsUseCase();
  }
};

export default container;
